import { BdsLoadingSpinner, BdsPaper } from 'blip-ds/dist/blip-ds-react/components';
import { ChipTag } from 'components/ChipTag';
import { Grid } from 'components/Grid';
import { MetricsContent } from 'components/MetricsContent';
import { MetricsTitle } from 'components/MetricsTitle';
import { useTranslation } from 'react-i18next';
import { MetricsLoadingProps } from 'typings/Loading';
import './AgentStatus.scss';

type AgentStatusProps = {
    averageTicketsPerAttendant?: number;
    online?: number;
    pause?: number;
    invisible?: number;
    loading: MetricsLoadingProps;
};

export function AgentStatus(agentStatus: AgentStatusProps) {
    const { t } = useTranslation();
    return (
        <BdsPaper width="40%" className="metricsContainer" elevation="none">
            <Grid justifyContent="space-between" alignItems="center" margin="x-2">
                <MetricsTitle title={t('go-personal-agent-status-title')} />
                <ChipTag
                    value={t('go-personal-loading-percentage', {
                        percentage: agentStatus.loading.attendanceMetricsPercentageLoaded ?? 0,
                    })}
                    color={agentStatus.loading.attendanceMetricsPercentageLoaded === 100 ? 'outline' : 'default'}
                />
            </Grid>
            {agentStatus.loading.isAttendanceMetricsLoading ? (
                <Grid justifyContent="center">
                    <BdsLoadingSpinner />
                </Grid>
            ) : (
                <Grid justifyContent="space-around" flexWrap="wrap" alignItems="center" gap="3" margin="x-2">
                    <MetricsContent metricsValue={agentStatus.averageTicketsPerAttendant}>
                        {t('go-personal-agent-status-avg-tickets')}
                    </MetricsContent>
                    <MetricsContent metricsValue={agentStatus.online}>
                        <div className="elipse" />
                        {t('go-personal-agent-status-online')}
                    </MetricsContent>
                    <MetricsContent metricsValue={agentStatus.pause}>
                        <div className="elipse backgroundYellow" />
                        {t('go-personal-agent-status-pause')}
                    </MetricsContent>
                    <MetricsContent metricsValue={agentStatus.invisible}>
                        <div className="elipse backgroundGrey" />
                        {t('go-personal-agent-status-invisible')}
                    </MetricsContent>
                </Grid>
            )}
        </BdsPaper>
    );
}
